import { create } from "zustand";

type TVideoController = {
  intensity: number;
  muted: boolean;
  videoRef: HTMLVideoElement | null;
  setCurrentVideo: (ref: HTMLVideoElement | null) => void;
  setVolume(intensity: number): void;
  setMuted(isMuted: boolean): void;
  toggleFullScreen: () => void;
};

const useVideoController = create<TVideoController>((set, get) => ({
  intensity: 100,
  muted: false,
  videoRef: null,
  setMuted(isMuted) {
    set({ muted: isMuted });
  },
  setVolume(intensity) {
    set({ intensity });
  },
  setCurrentVideo(videoRef) {
    set({ videoRef });
  },
  toggleFullScreen: () => {
    const ref = get().videoRef;
    if (ref !== null) {
      ref.requestFullscreen();
    }
  },
}));

export default useVideoController;
